import React from 'react';
import { List, Card, Rate, Button, Input, Space, Divider, Typography, Avatar, Alert, Popconfirm } from 'antd';
import { UserOutlined, CommentOutlined, DeleteOutlined } from '@ant-design/icons';
import moment from 'moment';

const { Text, Title } = Typography;
const { TextArea } = Input;

const ReviewsSection = ({ 
  reviews, 
  currentPage, 
  totalReviews, 
  PAGE_SIZE,
  userRating,
  reviewComment,
  currentUser,
  submittingReview,
  onPageChange,
  onRatingChange,
  onCommentChange,
  onReviewSubmit,
  isAdmin,
  onDeleteReview
}) => {
  return (
    <div className="card">
      <div className="header">
        <h2><strong>Ratings & Reviews</strong></h2>
      </div>
      <div className="body">
        {/* Reviews List */}
        <List
          itemLayout="vertical"
          dataSource={reviews}
          pagination={{
            onChange: onPageChange,
            current: currentPage,
            pageSize: PAGE_SIZE,
            total: totalReviews,
            showSizeChanger: false
          }}
          renderItem={review => (
            <List.Item
              style={{
                background: '#fff',
                padding: '20px',
                borderRadius: '8px',
                marginBottom: '16px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
              }}
              actions={isAdmin ? [
                <Popconfirm
                  title="Delete Review"
                  description="Are you sure you want to delete this review?"
                  onConfirm={() => onDeleteReview(review.id)}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button 
                    type="text" 
                    danger 
                    icon={<DeleteOutlined />}
                  >
                    Delete
                  </Button>
                </Popconfirm>
              ] : []}
            >
              <List.Item.Meta
                avatar={
                  <Avatar 
                    icon={<UserOutlined />} 
                    style={{ 
                      backgroundColor: '#1890ff',
                      marginRight: '12px'
                    }} 
                    size={40}
                  />
                }
                title={
                  <Text strong style={{ fontSize: '16px' }}>
                    {review.userName}
                  </Text>
                }
                description={
                  <Space direction="vertical" size={4}>
                    <Rate 
                      disabled 
                      defaultValue={review.rating} 
                      style={{ fontSize: '16px' }}
                    />
                    <Text type="secondary">
                      {moment(review.createdAt.toDate()).format('MMMM D, YYYY')}
                    </Text>
                  </Space>
                }
              />
              <div style={{ marginTop: '12px' }}>
                <Text>{review.comment}</Text>
              </div>
            </List.Item>
          )}
          style={{
            marginBottom: '32px'
          }}
        />

        {/* Divider between reviews and form */}
        <Divider style={{ margin: '32px 0' }}>
          <Text type="secondary">Write Your Review</Text>
        </Divider>

        {/* Review Form */}
        <Card 
          style={{ 
            marginTop: '24px',
            background: '#f8f9fa',
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
          }}
          className="review-form-card"
        >
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            <div>
              <Title level={4} style={{ marginBottom: '16px' }}>
                Rate Your Experience
              </Title>
              <Rate 
                value={userRating} 
                onChange={onRatingChange} 
                style={{ fontSize: '24px' }}
              />
            </div>
            <div>
              <Title level={4} style={{ marginBottom: '16px' }}>
                Share Your Thoughts
              </Title>
              <TextArea
                rows={4}
                value={reviewComment}
                onChange={onCommentChange}
                placeholder="Tell others about your experience..."
                style={{ 
                  borderRadius: '4px',
                  resize: 'none'
                }}
              />
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <Button 
                type="primary" 
                onClick={onReviewSubmit}
                loading={submittingReview}
                disabled={!currentUser}
                size="large"
                icon={<CommentOutlined />}
              >
                Submit Review
              </Button>
              {!currentUser && (
                <Alert
                  message="Please sign in to leave a review"
                  type="info"
                  showIcon
                  style={{ marginBottom: 0 }}
                />
              )}
            </div>
          </Space>
        </Card>
      </div>
    </div>
  );
};

export default ReviewsSection; 